<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-08 09:18:24
-->
<template>
  <div>
    <div class="maintitle">部门考核</div>
    <el-divider></el-divider>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="name" label="部门"></el-table-column>
      <el-table-column prop="month" width='120' label="考核月份"></el-table-column>
      <el-table-column label="是否评优" :formatter="formatExcellent"></el-table-column>
      <!-- <el-table-column label="当前状态" :formatter="formatStatus"></el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
            <el-button type='text' @click="$router.push('/kaohe/assessment/department/'+scope.row.id)" size='mini'>填报</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
    };
  },
  computed: {},
  methods: {
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/selfass/getAssessList",
        method: "post",
        data: {},
      }).then((res) => {
        this.list = res.data.list;
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    formatExcellent(col) {
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == col.selfexcellent) return this.excellentTypeList[i].excellent_title;
      }
      return '不评';
    },
    formatStatus(col) {
      switch (col.status) {
        case 0:
          return '未填报';
        case 11:
          return '暂存';
        case 12:
          return "已填报";
        case 32:
          return "已完成";
        default:
          return "等待最终考核";
      }
    }
  },
  created: function () {
    this.getlist();
  },
};
</script>
<style scoped>
.itemgroup {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px 20px 0 0;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
}
.itemgroup * {
  box-sizing: border-box;
}
.item-title {
  line-height: 28px;
}
</style>